/**
 * An instance of a track prop
 */
export class TrackPropInstance {
    /**
     * Construct a track prop instance
     */
    constructor() {
        this.objects = [];
    }

    /**
     * Instantiate this instance
     * @param {Scene} parent The parent scene to add the prop to
     * @param {Scene} scene The scene containing the meshes
     */
    instantiate(parent, scene) {

    }

    /**
     * Update the state
     */
    update() {

    }

    /**
     * Render a frame
     * @param {number} time The time interpolation in the range [0, 1]
     */
    render(time) {

    }

    /**
     * Delete instantiated objects
     * @param {Scene} parent The parent scene this instance was instantiated on
     */
    delete(parent) {
        for (const object of this.objects)
            parent.remove(object);

        this.objects.length = 0;
    }
}